import { PortalModule } from '@angular/cdk/portal';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatLineModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';

import { AppFrameModule } from '@oc-core/app-frame';
import { IconMenuModule } from '@oc-core/icon-menu';

import { BreadcrumbModule } from '../../components/breadcrumb/breadcrumb.module';
import { LoadingSpinnerComponent } from '../../components/loading-spinner/loading-spinner.component';
import { BackButtonModule } from '../../directives/back-button/back-button.module';
import { DefaultComponent } from './default.component';

@NgModule({
    declarations: [
        DefaultComponent, //
    ],
    imports: [
        CommonModule, //
        RouterModule,

        AppFrameModule,

        // Components
        MatListModule,
        MatIconModule,
        IconMenuModule,
        MatButtonModule,
        MatBadgeModule,
        MatLineModule,
        BreadcrumbModule,
        PortalModule,
        BackButtonModule,
        NgOptimizedImage,
        LoadingSpinnerComponent,
    ],
    exports: [
        DefaultComponent, //
    ],
})
export class DefaultModule {}
